import axios from "axios";
// import NProgress from 'nprogress';
// import pako from 'pako';
import { SETTINGS } from '../utils/settings'

// NProgress.configure({ showSpinner: false, easing: 'ease' });
// axios.interceptors.request.use((config) => {
//     config.metadata = { startTime: new Date() };
//     NProgress.start();
//     return config;
// }, (error) => {
//     NProgress.done();
//     return Promise.reject(error);
// });

//   // Response interceptor
// axios.interceptors.response.use((response) => {
//     NProgress.done();
//     const endTime = new Date();
//     const startTime = response.config.metadata.startTime;
//     const duration = (endTime - startTime) / 1000;
//     // console.debug(`RD: ${duration} Seconds`)
//     response.config.metadata.duration = duration;
//     if(response.data.Message === 'Session Expired'){
//         // eventBus.emit('openInAppLoginModal', {
//         //     'cmd': 'open-in-app-login-modal',
//         //     'value': null
//         // });
//         // TODO on top nav control internal login
//         // set that modal to display and blur out all content
//     }
//     return response;
// }, (error) => {
//     NProgress.done();
//     if (axios.isCancel(error)) {
//         // Request was cancelled, do nothing
//         return Promise.reject(error);
//     }
    
//     const config = error.config;
//     const currentTime = Date.now();
    
//       // Check if the request has timed out
//     if (config && config.timestamp && currentTime - config.timestamp >= config.timeout) {
//         // Handle the timeout error
//         // For example, you can throw a custom error or perform some action
//         console.log('Request timed out');
//         return Promise.reject(new Error('Request timed out'));
//     }
//     return Promise.reject(error);
// });

export function doPrivatePostRequest(_payload, _path, _token){
    const config = {
        method: 'post',
        url: `${SETTINGS.API_ENDPOINT}${_path}`,
        timeout: 180000,
        headers: { 
            'Content-Type': 'application/json',
            'TOKEN': _token
        },
        data : _payload
    };
    return axios(config)
}

export function doPrivateGetRequest(_path, _token){
    const config = {
        method: 'get',
        url: `${SETTINGS.API_ENDPOINT}${_path}`,
        timeout: 180000,
        headers: { 
            'Content-Type': 'application/json',
            'TOKEN': _token
        },
    };
    return axios(config)
}

export function doPrivatePostFormRequest(_payload, _path, _token) {
    const config = {
        method: 'post',
        url: `${SETTINGS.API_ENDPOINT}${_path}`,
        timeout: 180000,
        headers: {
            'TOKEN': _token
        },
        data: _payload
    };

    return axios(config);
}

export function doPrivateDownloadGet(_path, _token){
    const config = {
        method: 'get',
        url: `${SETTINGS.API_ENDPOINT}${_path}`,
        responseType: 'blob',
        timeout: 180000,
        headers: { 
            'Content-Type': 'application/json',
            'TOKEN': _token
        }
    };
    return axios(config)
}